import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axiosConfig from "../config.js";
import Dialog from "@mui/material/Dialog";
import Alert from "@mui/material/Alert";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import { Trash2 } from "lucide-react";
import { Trash } from "lucide-react";

// Custom dialog to show errors
function ErrorHandler({ open, onClose, payload }) {
  return (
    <Dialog fullWidth open={open} onClose={() => onClose()}>
      <DialogTitle> Error </DialogTitle>
      <DialogContent>
        <Alert severity="error">
          {"An error occurred while deleting this operation:"}
          <pre>{payload.error}</pre>
        </Alert>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose()}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}

export function DeleteButton() {
  const [isDeleting, setIsDeleting] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogPayload, setDialogPayload] = useState(null);
  const navigate = useNavigate();
  const { operationId } = useParams(); 

  const handleDialogClose = () => {
    setDialogOpen(false);
    setDialogPayload(null);
  };

  const handleDelete = async () => {
    // fix this pls thanks 
    const userEmail = prompt("To confirm, please re-enter your email:");
    console.log("operationId:", operationId);
    if (!userEmail) {
      alert("You must confirm your email to proceed.");
      return;
    } // or if userEmail != surgeon.id

    const deleteConfirmed = window.confirm(
      "Are you sure you want to delete this operation?"
    );
    if (!deleteConfirmed) {
      return;
    }
        try {
          
          setIsDeleting(true);
          const res = await axiosConfig.delete(`/operations/${operationId}`,
            {
              headers: { "User-Email": userEmail }, // @piotr maybe change these headers?
            }
          );
          if (res.status === 200) {
            alert("Operation deleted successfully!");
            navigate(-1); // Navigate back to the previous page
          }
        } catch (error) {
          const message =
            error.response?.data?.message || error.message || "Unknown error";
          setDialogPayload({ error: message });
          setDialogOpen(true);
        } finally {
          setIsDeleting(false);
        }
      };

  return (
    <div>
      <button
        className={`delete-button action-button ${isDeleting ? "loading" : ""}`}
        onClick={handleDelete}
        disabled={isDeleting}
      >
        {isDeleting ? <Trash size={16} /> : <Trash2 size={16} />}
      </button>

      {/* Error Dialogue Box */}
      {dialogOpen && (
        <ErrorHandler
          open={dialogOpen}
          onClose={handleDialogClose}
          payload={dialogPayload}
        />
      )}
    </div>
  );
}

